import { ALLOWED_ORIGINS, ALLOWED_PROTOCOLS } from '../constants/common';

export const safeWindowOpen = (url: string, opts?: { noreferrer?: boolean; base?: string }) => {
  try {
    const urlObj = new URL(url, opts?.base ?? window.location.origin);
    if (!ALLOWED_PROTOCOLS.includes(urlObj.protocol)) return false;
    if (!ALLOWED_ORIGINS.includes(urlObj.origin)) return false;
    const a = document.createElement('a');
    a.href = urlObj.href;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    a.remove();
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
